module.exports = __webpack_public_path__ + "img/pic.173d56d0.png";